<template>
    <el-dialog :visible.sync="show" title="添加/修改">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="账号描述">
                <el-input v-model="model.description"></el-input>
            </el-form-item>
            <el-form-item label="用户名">
                <el-input v-model="model.username"></el-input>
            </el-form-item>
            <el-form-item label="密码">
                <el-input v-model="model.password"></el-input>
            </el-form-item>
            <el-form-item label="店铺">
                <div class="line-container">
                    <el-input style="width:200px" v-model="store" disabled></el-input>
                    <el-button class="margin-l" type="primary" @click.stop="chooseItem('store')">选择</el-button>
                    <el-button class="margin-l" type="danger" icon="el-icon-delete" circle
                        @click.stop="removeItem('store')"></el-button>
                </div>
            </el-form-item>
            <el-form-item v-for="(menu,index) in myMenus" :label="menu.text">
                <el-checkbox v-for="child in menu.submenus" v-model="child.check">{{child.text}}</el-checkbox>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false">取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { selectStore } from "../../util/event.js";
import { HttpClient } from "../../util/http.js";
import { msgError, msgSuccess } from "../../util/toast";
import { menus } from "../../util/menu";

export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null,
            myMenus: [],
        };
    },
    computed: {
        store() {
            if (this.model.store) {
                return this.model.store.name;
            } else {
                return "";
            }
        },
    },
    created() {},
    methods: {
        async chooseItem(key) {
            if (key == "store") {
                let item = await selectStore();
                this.$set(this.model, key, item);
            }
        },
        removeItem(key) {
            this.$set(this.model, key, null);
        },
        addOrEdit(item) {
            this.show = true;
            this.model = this.deepCopy({
                ...item,
            });
            this.myMenus = this.deepCopy(
                menus.map((it) => {
                    it.submenus.map((it) => {
                        it["check"] =
                            this.model.pagePermission &&
                            this.model.pagePermission.includes(it.path);
                        return it;
                    });
                    return it;
                })
            );
        },
        async save() {
            if (
                !this.model.username ||
                this.model.username == "" ||
                !this.model.password ||
                this.model.password == ""
            ) {
                return msgError("用户名和密码不能少");
            }
            this.loadingSave = true;
            // this.model = { ...this.model, masterAdmin: false };
            let pagePermission = "";
            this.myMenus.forEach((it) => {
                it.submenus = it.submenus.forEach((it) => {
                    if (it.check) {
                        pagePermission += it.path + "|";
                    }
                });
            });
            await HttpClient.put("/restful", {
                model: "Admin",
                cond: this.model._id,
                updates: { ...this.model, pagePermission },
            });
            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        },
    },
};
</script>

<style scoped lang="less">
</style>

        